import { useQuery } from "@tanstack/react-query";

import { getBillingStatus } from "@/lib/api/billing";

export const BILLING_STATUS_QUERY_KEY = ["billing-status"] as const;

interface UseBillingStatusQueryOptions {
  enabled?: boolean;
  refetchInterval?: number | false;
}

export const useBillingStatusQuery = ({
  enabled,
  refetchInterval,
}: UseBillingStatusQueryOptions = {}) =>
  useQuery({
    queryKey: BILLING_STATUS_QUERY_KEY,
    queryFn: () => getBillingStatus().then((res) => res.data),
    enabled,
    refetchInterval,
    staleTime: 60 * 1000,
  });
